var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "place-component" }, [
    _c("h3", [_vm._v(_vm._s(_vm.eventName))]),
    _vm._v(" "),
    _c("p", { staticClass: "date" }, [_vm._v(_vm._s(_vm.time))]),
    _vm._v(" "),
    _c("img", { attrs: { src: _vm.image, alt: _vm.eventName } }),
    _vm._v(" "),
    _c("div", { staticClass: "address" }, [
      _c("span", { staticClass: "name" }, [_vm._v(_vm._s(_vm.locationName))]),
      _vm._v(" "),
      _c("span", { staticClass: "line-1" }, [_vm._v(_vm._s(_vm.address))]),
      _vm._v(" "),
      _c("span", { staticClass: "city-state" }, [
        _vm._v(
          _vm._s(_vm.city) + " " + _vm._s(_vm.state) + ", " + _vm._s(_vm.zip)
        )
      ])
    ]),
    _vm._v(" "),
    _c("a", { attrs: { href: _vm.directionsLink, target: "_blank" } }, [
      _vm._v("\n        Get Directions\n    ")
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "instructions" }, [
      _vm._v("*" + _vm._s(_vm.instructions))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3bb26cb2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bb26cb2","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/place.vue
// module id = 68
// module chunks = 0